import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import styles from "../../assets/styles/salesSlotBooking.module.css";
import { SlProgressBar } from "@shoelace-style/shoelace/dist/react";
import {
  SlDrawer,
  SlButton,
  SlIcon,
} from "@shoelace-style/shoelace/dist/react";
import { Toast } from "../../shared/Toast";
import API from "../../services/api";
import { formatDateDDMMYYY, formatDateWithTime, formatDateYYYYMMDD } from "../../utils/dateFormat";
import downloadIconSvg from "../../assets/images/download-icon-big.svg";
import approveSvg from "../../assets/images/approve-icon.svg";
import closeCrossIconSvg from "../../assets/images/close_cross_icon.svg";
import rejectSvg from "../../assets/images/reject-icon.svg";
import {
  billingOptions,
  formatAmount,
  getNumberOfDays,
  langoptions_preview,
  rejectMessOptions,
  roles,
  slotBookingCreativeTypes,
  slotPackagesOptions,
  slotPaymentMethodOptions,
  slotPaymentTypeOptions,
} from "../../utils/constants";
import PdfViewer from "../Orders/PdfViewer";
import SlotHistory from "./SlotHistory";
import OrderEditLogs from "../Orders/OrderEditLogs";
import { useNavigate } from "react-router";

function SlotVIew(props) {
  let { slot_id, setSlot_id } = props;
  const navigate = useNavigate();
  const [viewData, setViewData] = useState(null);
  const [cstOrderData, setCstOrderData] = useState(null);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const rejectForm = useForm({ mode: "all" });
  const selectedReasons = rejectForm.watch("reason", []);
  const [pdfUrl, setPdfUrl] = useState("");
  const [noOfDays, setNoOfDays] = useState(0);
  const now = new Date();
  const midnight =
    new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime() / 1000; // Convert to seconds
  const [showApproveModal, setShowApproveModal] = useState(false);
  const [approveReasonUrl, setApproveReasonUrl] = useState("");
  const approveForm = useForm({ mode: "all" });
  const [viewEditHistoryId, setViewEditHistoryId] = useState(null);
  const [approveReasonprogress, setApproveReasonprogress] = useState(0);
  const [orderEditLogsId, setOrderEditLogsId] = useState(null);
  const [cstHeadAppRejObj, setCstHeadAppRejObj] = useState(null);
  const getStatusDetails = async () => {
    try {
      let res = await API({
        url: "/slotbooking/status-details",
        method: "POST",
        responseType: "json",
        data: {
          slot_id: viewData.slot_id,
        },
      });
      if (res.code === 200) {
        setViewData({ ...viewData, ...res.data });
      }
    } catch (error) {
      console.error("Error @ getStatusDetails", error);
    }
  };
  const getViewData = async () => {
    try {
      let apiResult = await API({
        url: "/slotbooking/slot_details",
        method: "POST",
        responseType: "json",
        data: { slot_id },
      });
      if (apiResult.code === 200) setViewData(apiResult.data);
    } catch (error) {
      console.error("Error @ getViewData", error);
      if (error.response.status === 401) navigate("/");
    }
  };

  const getCstOrderDetails = async (order_id) => {
    try {
      let apiResult = await API({
        url: "/order/getCstOrderDetails",
        method: "POST",
        responseType: "json",
        data: { order_id },
      });
      if (apiResult.code === 200) setCstOrderData(apiResult.data);
    } catch (error) {
      console.error("Error @ getCstOrderDetails", error);
    }
  };

  useEffect(() => {
    if (slot_id) getViewData();
  }, []);

  useEffect(() => {
    // if (viewData) setNoOfDays(getNumberOfDays(viewData.date_ranges));
    if (localStorage.getItem("role") === roles.ops && viewData?.order_id) {
      getCstOrderDetails(viewData?.order_id);
    }
  }, [viewData]);

  const handleDownload = async (url, brand) => {
    const pdfUrl = url;

    try {
      const response = await fetch(pdfUrl);
      const blob = await response.blob();
      const fileType = pdfUrl.split(".").pop();
      // Create a link element
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `${brand}.${fileType}`;

      // Append the link to the body
      document.body.appendChild(link);

      // Trigger a click on the link to start the download
      link.click();

      // Remove the link from the body after the download is complete
      document.body.removeChild(link);
    } catch (error) {
      Toast("error", "Error downloading PDF");
      console.error("Error downloading PDF:", error);
    }
  };
  // Validation function
  const validateReasons = () => {
    return selectedReasons.length > 0;
  };
  const handleReject = async (data) => {
    try {
      let res = await API({
        url: "/slotbooking/reject-booking",
        method: "POST",
        responseType: "json",
        data: {
          reason: data.reason,
          slot_id: viewData.slot_id,
          description: data.description,
        },
      });
      if (res.code === 200) {
        Toast("success", res.data || res.message);
        getViewData();
        setShowRejectModal(false);
      }
    } catch (error) {
      console.error("Error Rejecting booking:", error);
    }
  };
  const handleApprove = async (data) => {
    try {
      let reqObj = { slot_id: viewData.slot_id };
      if (localStorage.getItem("role") === roles.salesperson) {
        reqObj.approvereason_url = approveReasonUrl;
        reqObj.approve_description = data.description;
      }
      let res = await API({
        url: "/slotbooking/approve-booking",
        method: "POST",
        responseType: "json",
        data: reqObj,
      });
      if (res.code === 200) {
        getViewData();
        setShowApproveModal(false);
        Toast("success", res.data || res.message);
      }
    } catch (error) {
      console.error("Error fetching brands:", error);
    }
  };
  const handleCreateSlotOrder = async (slot_id) => {
    try {
      let res = await API({
        url: "/slotbooking/create-slot-order",
        method: "POST",
        responseType: "json",
        data: {
          slot_id: slot_id,
        },
      });
      if (res.code === 200) {
        getViewData();
        if (res.data) {
          Toast("error", res.data);
        } else Toast("success", res.data || res.message);
      }
    } catch (error) {
      console.error("Error @ handleCreateSlotOrder", error);
    }
  };
  const handleCSTHeadApprove = async (data) => {
    try {
      let res = await API({
        url: "/order/order-edit-approve",
        method: "POST",
        responseType: "json",
        data: { ...data, ...cstHeadAppRejObj },
      });
      if (res.code === 200) {
        getViewData();
        if (res.data) {
          Toast("error", res.data);
          getCstOrderDetails(viewData?.order_id);
        } else Toast("success", res.data || res.message);
      }
      setCstHeadAppRejObj(null);
    } catch (error) {
      console.error("Error @ handleCreateSlotOrder", error);
    }
  };
  const handleViewEditHistory = () => {
    setViewEditHistoryId(JSON.parse(JSON.stringify(viewData?.slot_id)));
  };

  const uploadroFile = async (formData, fileType) => {
    try {
      let res = await API({
        url: "/upload/file-upload",
        method: "POST",
        responseType: "json",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (data) => {
          setApproveReasonprogress(
            Math.round((100 * data.loaded) / data.total)
          );
        },
      });
      if (res.code === 200) {
        if (fileType === "approvereason_url") {
          setApproveReasonUrl(res.data?.data);
        }
        Toast("success", "File uploaded successfully");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleFileChange = async (e, fileType) => {
    if (e.target.files.length) {
      const formData = new FormData();
      formData.append("files", e.target.files[0]);
      await uploadroFile(formData, fileType);
    } else {
    }
  };

  return (
    <SlDrawer
      open={slot_id ? true : false}
      onSlAfterHide={() => {
        setSlot_id(null);
        localStorage.removeItem("slot-id");
      }}
      onSlRequestClose={(event) => {
        if (event.detail.source === "overlay") {
          event.preventDefault();
          setSlot_id(null);
          localStorage.removeItem("slot-id");
        }
      }}
      label={viewData?.slot_name}
      style={{ "--size": "1000px" }}
      // className={styles["sldrawer-container"]}
      class="drawer-scrolling"
    >
      {localStorage.getItem("role") === roles.ops ? (
        <h3 className="mb-2">Sales Order Details</h3>
      ) : null}
      <div className={styles["slotView-body"]}>
        <section className="flex gap-6 overflow-x-hidden mb-3">
          <div className="basis-full grid gap-6 grid-cols-5050">
            {viewData ? (
              <>
                <section className="bg-slate-50 py-4 px-6 rounded-lg">
                  {viewData.sales_name ? <div className="flex justify-between mb-2">
                    <label className="text-slate-500">Sales Person : </label>
                    <span>{viewData.sales_name}</span>
                  </div> : null}
                  {viewData.brand_name ? <div className="flex justify-between mb-2">
                    <label className="text-slate-500">Brand : </label>
                    <span>{viewData.brand_name}</span>
                  </div> : null}
                  {viewData.company_name ? <div className="flex justify-between mb-2">
                    <label className="text-slate-500">Company : </label>
                    <div
                      className={
                        viewData.verified_status == 1
                          ? "full-badge text-center"
                          : viewData.verified_status === 2
                          ? "pending-badge text-center"
                          : "unpaid-badge text-center"
                      }
                    >
                      <span>
                        {viewData.company_name}{" "}
                        {viewData.verified_status === 1 ? (
                          <sl-icon name="patch-check-fill"></sl-icon>
                        ) : viewData.verified_status === 2 ? (
                          <sl-icon name="x-circle-fill"></sl-icon>
                        ) : (
                          <sl-icon name="patch-check-fill"></sl-icon>
                        )}
                      </span>
                    </div>
                  </div> : null}
                  {viewData.status ? <div className="flex justify-between mb-2">
                    <label className="text-slate-500">Status : </label>
                    <span
                      className={
                        viewData.status === 1
                          ? "Pending_batch"
                          : viewData.status === 2
                          ? "Finance_Pending_batch"
                          : viewData.status === 3
                          ? "Approved_batch"
                          : viewData.status === 4
                          ? "Rejected_batch"
                          : "Deleted_batch"
                      }
                    >
                      {viewData.status === 1
                        ? "Pending"
                        : viewData.status === 2
                        ? "Finance Pending"
                        : viewData.status === 3
                        ? "Approved"
                        : viewData.status === 4
                        ? "Rejected"
                        : "Deleted"}
                    </span>
                  </div> : null}
                  {viewData.approval_obj?.sales_head_name ? (
                    <div className="flex justify-between mb-2">
                      <label className="text-slate-500">Sales head : </label>
                      <span>{viewData.approval_obj.sales_head_name}</span>
                    </div>
                  ) : null}
                  {viewData.approval_obj?.fin_head_name ? (
                    <div className="flex justify-between mb-2">
                      <label className="text-slate-500">Financer : </label>
                      <span>{viewData.approval_obj.fin_head_name}</span>
                    </div>
                  ) : null}
                  {viewData.approval_obj?.cst_name ? (
                    <div className="flex justify-between mb-2">
                      <label className="text-slate-500">
                        Order Picked By :{" "}
                      </label>
                      <span>{viewData.approval_obj.cst_name}</span>
                    </div>
                  ) : null}
                  {viewData.approval_obj?.description ? (
                    <div className="flex justify-between mb-2">
                      <label className="text-slate-500">
                        Reject Description :{" "}
                      </label>
                      <span>{viewData.approval_obj?.description}</span>
                    </div>
                  ) : null}
                  {viewData.approval_obj?.reason ? (
                    <div className="flex justify-between mb-2">
                      <label className="text-slate-500">Reject Reason : </label>
                      <span>
                        {viewData.approval_obj?.reason
                          .map((index) => rejectMessOptions[index])
                          .join(", ")}
                      </span>
                    </div>
                  ) : null}
                  {viewData.approval_obj?.approve_description ? (
                    <div className="flex justify-between mb-2">
                      <label className="text-slate-500">
                        Approved Description :{" "}
                      </label>
                      <span>{viewData.approval_obj?.approve_description}</span>
                    </div>
                  ) : null}
                </section>
                {(viewData.headApprove ||
                          viewData.finApprove ||
                          localStorage.getItem("role") === roles.ops || viewData.mine) ? <section className="bg-slate-50 py-4 px-6 rounded-lg">
                  <h6 className="mb-2">Payment Details</h6>
                  {viewData.payment_type ? <div className="flex justify-between mb-2">
                    <label className="text-slate-500">Payment Type :</label>{" "}
                    {
                      slotPaymentTypeOptions.find(
                        (item) => item.value === viewData.payment_type
                      )?.label
                    }
                  </div> : null}
                  {viewData.payment_method ? (
                    <div className="flex justify-between mb-2">
                      <label className="text-slate-500">Payment Method :</label>{" "}
                      {
                        slotPaymentMethodOptions.find(
                          (item) => item.value === viewData.payment_method
                        )?.label
                      }
                    </div>
                  ) : null}
                  {viewData.package_no ? <div className="flex justify-between mb-2">
                    <label className="text-slate-500">Package :</label>{" "}
                    {
                      slotPackagesOptions.find(
                        (item) => item.value === viewData.package_no
                      )?.label
                    }
                  </div> : null}
                  {viewData.payment_id ? <div className="flex justify-between mb-2">
                    <label className="text-slate-500">
                      Payment Id / RO.no :
                    </label>{" "}
                    {viewData.payment_id}
                  </div> : null}
                  {viewData.ro_value ? <div className="flex justify-between mb-2">
                    <label className="text-slate-500">Ro Value :</label>{" "}
                    <span>{viewData.ro_value}</span>
                  </div> : null}
                  {viewData.billing ? <div className="flex justify-between mb-2">
                    <label className="text-slate-500">Billing Type :</label>{" "}
                    {
                      billingOptions.find(
                        (item) => item.value === viewData.billing
                      )?.label
                    }
                  </div> : null}

                  {viewData.non_billing_order_id ? (
                    <div className="flex justify-between mb-2">
                      <label className="text-slate-500">
                        Non Billing Order Id :
                      </label>{" "}
                      {viewData.non_billing_order_id}
                    </div>
                  ) : null}
                  {viewData.order_id ? (
                    <div className="flex justify-between mb-2">
                      <label className="text-slate-500">Order Id :</label>{" "}
                      {viewData.order_id}
                    </div>
                  ) : null}
                  {viewData.description ? (
                    <div className="flex justify-between mb-2 flex-col">
                      <label className="text-slate-500">Description :</label>{" "}
                      {viewData.description}
                    </div>
                  ) : null}
                </section> : null}
                {viewData.internal_details.map((internalItem, index) => {
                  let noOfDays = getNumberOfDays(internalItem.date_ranges);
                  return (
                    <section className="bg-slate-50 py-4 px-6 rounded-lg">
                      <h6 className="mb-1 ">{`Ad Unit ID ${internalItem.internal_id}`}</h6>
                      <div className="flex justify-between mb-2">
                        <label className="text-slate-500">Date Ranges</label>
                        <span className="d-flex flex-col gap-1">
                          {internalItem.date_ranges.map((item) => {
                            return (
                              <span>
                                {/* {formatDateWithTime(item.start_date)} -
                                {formatDateWithTime(item.end_date)}{" "} */}
                                {formatDateDDMMYYY(item.start_date)} {" - "}
                                {formatDateDDMMYYY(item.end_date)}{" "}
                              </span>
                            );
                          })}
                        </span>
                      </div>
                      {internalItem.campaign_type ? <div className="flex justify-between mb-2">
                        <label className="text-slate-500">
                          Campaign Type :{" "}
                        </label>
                        <span>{internalItem.campaign_type}</span>
                      </div> : null}
                      {internalItem.creative_type ? <div className="flex justify-between mb-2">
                        <label className="text-slate-500">
                          Creative Type :{" "}
                        </label>
                        <span>
                          {
                            slotBookingCreativeTypes.find(
                              (item) =>
                                item.value === internalItem.creative_type
                            )?.label
                          }
                        </span>
                      </div> : null}
                      {internalItem.campaign_type === "CPD" ? (
                        <>
                          <div className="flex justify-between mb-2">
                            <label className="text-slate-500">Position :</label>{" "}
                            {`${internalItem.positions.map((position) =>
                              position === -1 ? "SOV" : `P${position}`
                            )}`}
                          </div>
                          <div className="flex justify-between mb-2">
                            <label className="text-slate-500">Slot :</label>{" "}
                            {internalItem.slot === 0
                              ? "A"
                              : internalItem.slot === 1
                              ? "B"
                              : internalItem.slot === 2
                              ? "C"
                              : "-"}
                          </div>
                        </>
                      ) : null}
                      {internalItem.adunit_budget ? <div className="flex justify-between mb-2">
                        <label className="text-slate-500">Budget :</label>{" "}
                        <span>{internalItem.adunit_budget.toFixed(2)}</span>
                      </div> : null }

                      {internalItem.campaign_type === "CPD" ? (
                        <>
                          {internalItem.sales_price ? <div className="flex justify-between mb-2">
                            <label className="text-slate-500">
                              Per Day Budget :
                            </label>{" "}
                            <span>{internalItem.sales_price.toFixed(2)}</span>
                          </div> : null}
                          {(viewData.headApprove ||
                          viewData.finApprove ||
                          localStorage.getItem("role") === roles.ops) && internalItem.actual_price ? (
                              <div className="flex justify-between mb-2">
                              <label className="text-slate-500">
                                Actual CPD Price :
                              </label>{" "}
                              <span>{`${
                                internalItem.actual_price * noOfDays
                              }  ${
                                noOfDays > 1 ? `(${noOfDays} Days)` : ""
                              }`}</span>
                            </div>
                          ) : null}
                          {(viewData.headApprove ||
                            viewData.finApprove ||
                            localStorage.getItem("role") === roles.ops) &&
                          noOfDays > 1 && internalItem.actual_price ? (
                            <div className="flex justify-between mb-2">
                              <label className="text-slate-500">
                                Actual CPD Price per Day :
                              </label>{" "}
                              <span>{internalItem.actual_price}</span>
                            </div>
                          ) : null}
                        </>
                      ) : viewData.campaign_type === "CPM" ? (
                        <>
                          {(viewData.headApprove ||
                          viewData.finApprove ||
                          localStorage.getItem("role") === roles.ops) && internalItem.actual_price ? (
                            <div className="flex justify-between mb-2">
                              <label className="text-slate-500">
                                Actual CPM Price :
                              </label>{" "}
                              <span>{internalItem.actual_price}</span>
                            </div>
                          ) : null}
                          <div className="flex justify-between mb-2">
                            <label className="text-slate-500">
                              {viewData.headApprove ||
                              viewData.finApprove ||
                              localStorage.getItem("role") === roles.ops
                                ? "Sales Person CPM Price :"
                                : "CPM Price"}
                            </label>{" "}
                            <span>{internalItem.sales_price}</span>
                          </div>
                          <div className="flex justify-between mb-2">
                            <label className="text-slate-500">
                              Actual Total Impressions :
                            </label>{" "}
                            <span
                              title={parseInt(
                                (internalItem.adunit_budget * 1000) /
                                  internalItem.actual_price
                              )}
                            >
                              {formatAmount(
                                parseInt(
                                  (internalItem.ro_value * 1000) /
                                    internalItem.actual_price
                                )
                              )}
                            </span>
                          </div>
                          {(viewData.headApprove ||
                          viewData.finApprove ||
                          localStorage.getItem("role") === roles.ops) && internalItem.adunit_budget && internalItem.sales_price  ? (
                            <div className="flex justify-between mb-2">
                              <label className="text-slate-500">
                                Salesperson's Total Impressions :
                              </label>{" "}
                              <span
                                title={parseInt(
                                  (internalItem.adunit_budget * 1000) /
                                    internalItem.sales_price
                                )}
                              >
                                {formatAmount(
                                  parseInt(
                                    (internalItem.adunit_budget * 1000) /
                                      internalItem.sales_price
                                  )
                                )}
                              </span>
                            </div>
                          ) : null}
                        </>
                      ) : null}
                      {(viewData.headApprove ||
                      viewData.finApprove ||
                      localStorage.getItem("role") === roles.ops) && internalItem.actual_price && internalItem.sales_price && internalItem.adunit_budget ? (
                        <div className="flex justify-between mb-2">
                          <label className="text-slate-500">Difference :</label>{" "}
                          <span>
                            {internalItem.campaign_type === "CPM"
                              ? `${
                                  internalItem.actual_price -
                                    internalItem.sales_price >
                                  0
                                    ? "-"
                                    : "+"
                                } ${Math.abs(
                                  internalItem.actual_price -
                                    internalItem.sales_price
                                )} (${Math.abs(
                                  (100 / internalItem.actual_price) *
                                    (internalItem.actual_price -
                                      internalItem.sales_price)
                                ).toFixed(2)}%)`
                              : `${
                                  internalItem.actual_price * noOfDays -
                                    internalItem.adunit_budget >
                                  0
                                    ? "-"
                                    : "+"
                                } ${Math.abs(
                                  internalItem.actual_price * noOfDays -
                                    internalItem.adunit_budget
                                )} (${Math.abs(
                                  (100 /
                                    (internalItem.actual_price * noOfDays)) *
                                    (internalItem.actual_price * noOfDays -
                                      internalItem.adunit_budget)
                                ).toFixed(2)}%)`}
                          </span>
                        </div>
                      ) : null}
                      <h6 className="mb-2">Target</h6>
                      {internalItem.actualTarget?.lang_ids?.length > 0 && (
                        <div className="flex justify-between mb-2">
                          <label className="text-slate-500">Languages :</label>{" "}
                        </div>
                      )}
                      {Array.isArray(internalItem?.actualTarget?.lang_ids) &&
                        internalItem.actualTarget?.lang_ids?.length > 0 &&
                        internalItem?.actualTarget?.lang_ids.map((item, i) => {
                          return <p key={i}>{langoptions_preview[item]}</p>;
                        })}
                      {Array.isArray(internalItem?.actualTarget?.state_ids) &&
                        internalItem.actualTarget.state_ids?.length > 0 && (
                          <div className="mb-2">
                            <label className="text-slate-500">States : </label>
                            {internalItem.state_Objs
                              .filter((st) =>
                                internalItem.actualTarget.state_ids.includes(
                                  st.state_id
                                )
                              )
                              .map((item) => {
                                return <p>{item.state_name}</p>;
                              })}
                          </div>
                        )}
                      {Array.isArray(
                        internalItem?.actualTarget?.district_ids
                      ) &&
                        internalItem.actualTarget.district_ids?.length > 0 && (
                          <div className="mb-2">
                            {
                              <label className="text-slate-500">
                                Districts :{" "}
                              </label>
                            }
                            {internalItem.district_Objs
                              .filter((di) =>
                                internalItem.actualTarget.district_ids.includes(
                                  di.dist_id
                                )
                              )
                              .map((item, i) => (
                                <p
                                  key={i}
                                >{`${item.dist_name}(D), ${item.state_name}(S)`}</p>
                              ))}
                          </div>
                        )}

                      {Array.isArray(internalItem?.constituency_Objs) &&
                        internalItem.constituency_Objs?.length > 0 && (
                          <div className="mb-2">
                            <label className="text-slate-500">
                              Constituencies :{" "}
                            </label>
                            {internalItem.constituency_Objs.map((item, i) => {
                              return (
                                <p
                                  key={i}
                                >{`${item.const_name}(C), ${item.district_name}(D)`}</p>
                              );
                            })}
                          </div>
                        )}
                    </section>
                  );
                })}
                {viewData?.package_order ? (
                    <div className="bg-slate-50 flex flex-col mb-2 px-8">
                      <h6 className="text-black">Package Details : </h6>
                      {viewData?.package_type ? <div className="flex justify-between"><label className="text-slate-500">Package Type : </label><p className="text-slate-500">{viewData?.package_type}</p></div> : null}
                      {viewData?.package_weeks ? <div className="flex justify-between"><label className="text-slate-500">Package Week : </label><p className="text-slate-500">{viewData?.package_weeks}</p></div> : null}
                      {viewData?.package_value ? <div className="flex justify-between"><label className="text-slate-500">Package Value : </label><p className="text-slate-500">{viewData?.package_value}</p></div> : null}
                    </div>
                  ) : null}
                {viewData.rofile_url ? (
                  <section className="bg-slate-50 py-4 px-6 rounded-lg">
                    <div className="flex justify-between mb-2 flex-col  h-[350px]">
                      <label className="text-slate-500">Ro File :</label>{" "}
                      <embed
                        className="w-full h-full"
                        type="application/pdf"
                        src={viewData.rofile_url}
                        aria-label="RO PDF Document"
                      ></embed>
                      {viewData.rofile_url ? (
                        <div className="d-flex gap-1 items-center mb-3">
                          <p className="text-xs text-blue-400 m-0">
                            {viewData.rofile_url}
                          </p>
                          <sl-icon-button
                            title="View campaign certificate Document"
                            library="lucide"
                            name="view"
                            onClick={() => {
                              setPdfUrl(viewData.rofile_url);
                            }}
                          ></sl-icon-button>
                        </div>
                      ) : null}
                    </div>
                  </section>
                ) : null}
                {viewData.nonbillfile_url ? (
                  <section className="bg-slate-50 py-4 px-6 rounded-lg">
                    <div className="flex justify-between mb-2 flex-col h-[350px]">
                      <label className="text-slate-500">
                        Non Billing Reason :
                      </label>{" "}
                      <embed
                        className="w-full h-full"
                        type="application/pdf"
                        src={viewData.nonbillfile_url}
                        aria-label="RO PDF Document"
                      ></embed>
                      {viewData.nonbillfile_url ? (
                        <div className="d-flex gap-1 items-center mb-3">
                          <p className="text-xs text-blue-400 m-0">
                            {viewData.nonbillfile_url}
                          </p>
                          <sl-icon-button
                            title="View campaign certificate Document"
                            library="lucide"
                            name="view"
                            onClick={() => {
                              setPdfUrl(viewData.nonbillfile_url);
                            }}
                          ></sl-icon-button>
                        </div>
                      ) : null}
                    </div>
                  </section>
                ) : null}
                {viewData.pdcfile_url ? (
                  <section className="bg-slate-50 py-4 px-6 rounded-lg">
                    <div className="flex justify-between mb-2 flex-col h-[350px]">
                      <label className="text-slate-500">PDC File :</label>{" "}
                      <embed
                        className="w-full h-full"
                        type="application/pdf"
                        src={viewData.pdcfile_url}
                        aria-label="RO PDF Document"
                      ></embed>
                      {viewData.pdcfile_url ? (
                        <div className="d-flex gap-1 items-center mb-3">
                          <p className="text-xs text-blue-400 m-0">
                            {viewData.pdcfile_url}
                          </p>
                          <sl-icon-button
                            title="View campaign certificate Document"
                            library="lucide"
                            name="view"
                            onClick={() => {
                              setPdfUrl(viewData.pdcfile_url);
                            }}
                          ></sl-icon-button>
                        </div>
                      ) : null}
                    </div>
                  </section>
                ) : null}
                {viewData?.approval_obj?.approvereason_url ? (
                  <section className="bg-slate-50 py-4 px-6 rounded-lg">
                    <div className="flex justify-between mb-2 flex-col h-[350px]">
                      <label className="text-slate-500">
                        Sales Head Approved Reason :
                      </label>{" "}
                      <embed
                        className="w-full h-full"
                        type="application/pdf"
                        src={viewData?.approval_obj?.approvereason_url}
                        aria-label="RO PDF Document"
                      ></embed>
                      {viewData?.approval_obj?.approvereason_url ? (
                        <div className="d-flex gap-1 items-center mb-3">
                          <p className="text-xs text-blue-400 m-0">
                            {viewData?.approval_obj?.approvereason_url}
                          </p>
                          <sl-icon-button
                            title="View campaign certificate Document"
                            library="lucide"
                            name="view"
                            onClick={() => {
                              setPdfUrl(
                                viewData?.approval_obj?.approvereason_url
                              );
                            }}
                          ></sl-icon-button>
                        </div>
                      ) : null}
                    </div>
                  </section>
                ) : null}
                {viewData.image_url ? (
                  <section className="bg-slate-50 py-4 px-6 rounded-lg">
                    <div className="flex justify-between mb-2 flex-col  h-[350px]">
                      <label className="text-slate-500">Image :</label>{" "}
                      <embed
                        className="w-full h-full"
                        type="image/jpeg"
                        src={viewData.image_url}
                        aria-label="Image"
                      ></embed>
                      {viewData.image_url ? (
                        <div className="d-flex gap-1 items-center mb-3">
                          <p className="text-xs text-blue-400 m-0">
                            {viewData.image_url}
                          </p>
                          <sl-icon-button
                            title="View Image"
                            library="lucide"
                            name="view"
                            onClick={() => {
                              setPdfUrl(viewData.image_url);
                            }}
                          ></sl-icon-button>
                        </div>
                      ) : null}
                    </div>
                  </section>
                ) : null}
              </>
            ) : null}
          </div>
        </section>
      </div>
      {cstOrderData ? (
        <>
          {" "}
          {localStorage.getItem("role") === roles.ops ? (
            <h3 className="mb-2">CST Order Details</h3>
          ) : null}
          <div>
            <section className="flex gap-6 overflow-x-hidden">
              <div className="basis-full grid gap-6 grid-cols-5050">
                {cstOrderData ? (
                  <>
                    <section className="bg-slate-50 py-4 px-6 rounded-lg">
                      <div className="flex justify-between mb-2">
                        <label className="text-slate-500">Order Name : </label>
                        <span>{cstOrderData.order_name}</span>
                      </div>
                      <div className="flex justify-between mb-2">
                        <label className="text-slate-500">Start Date : </label>
                        <span>
                          {formatDateYYYYMMDD(cstOrderData.o_start_date)}
                        </span>
                      </div>
                      <div className="flex justify-between mb-2">
                        <label className="text-slate-500">End Date : </label>
                        <span>
                          {formatDateYYYYMMDD(cstOrderData.o_end_date)}
                        </span>
                      </div>
                      <div className="flex justify-between mb-2">
                        <label className="text-slate-500">Company : </label>
                        <span>{cstOrderData.company_name}</span>
                      </div>
                      <div className="flex justify-between mb-2">
                        <label className="text-slate-500">
                          Sales Person :{" "}
                        </label>
                        <span>{cstOrderData.sales_name}</span>
                      </div>
                      <div className="flex justify-between mb-2">
                        <label className="text-slate-500">Order Value : </label>
                        <span>{cstOrderData.order_value}</span>
                      </div>
                      <div className="flex justify-between mb-2">
                        <label className="text-slate-500">Payment type :</label>{" "}
                        <span>
                          {
                            slotPaymentTypeOptions.find(
                              (item) => item.value === cstOrderData.payment_type
                            )?.label
                          }
                        </span>
                      </div>
                      {cstOrderData?.payment_details?.cheque_no ? (
                        <div className="flex justify-between mb-2">
                          <label className="text-slate-500">
                            Payment Id :{" "}
                          </label>
                          <span>
                            {cstOrderData?.payment_details?.cheque_no}
                          </span>
                        </div>
                      ) : null}
                      {cstOrderData?.payment_details?.amount ? (
                        <div className="flex justify-between mb-2">
                          <label className="text-slate-500">
                            Payment Amount :{" "}
                          </label>
                          <span>{cstOrderData?.payment_details?.amount}</span>
                        </div>
                      ) : null}
                      {cstOrderData.ro_no ? (
                        <div className="flex justify-between mb-2">
                          <label className="text-slate-500">Ro Number : </label>
                          <span>{cstOrderData.ro_no}</span>
                        </div>
                      ) : null}
                      <div className="flex justify-between mb-2">
                        <label className="text-slate-500">Internal : </label>
                        <span>{cstOrderData.internal ? "Yes" : "No"}</span>
                      </div>
                      {cstOrderData.edit_status?.status ? (
                        <div className="flex justify-between mb-2">
                          <label className="text-slate-500">
                            Order Edit Approval :{" "}
                          </label>
                          <span
                            className={
                              cstOrderData.edit_status?.status === 1
                                ? "text-purple-600"
                                : cstOrderData.edit_status?.status === 2
                                ? "text-red-600"
                                : ""
                            }
                          >
                            {cstOrderData.edit_status?.status === 1
                              ? "Pending"
                              : "Rejected"}
                          </span>
                        </div>
                      ) : null}
                      {cstOrderData.edit_status?.reason ? (
                        <div className="flex justify-between mb-2">
                          <label className="text-slate-500">
                            Rejected Reason :{" "}
                          </label>
                          <span>{cstOrderData.edit_status?.reason}</span>
                        </div>
                      ) : null}
                    </section>

                    {cstOrderData.rofile_url ? (
                      <section className="bg-slate-50 py-4 px-6 rounded-lg">
                        <div className="flex justify-between mb-2 flex-col  h-[350px]">
                          <label className="text-slate-500">Ro File :</label>{" "}
                          <embed
                            className="w-full h-full"
                            type="application/pdf"
                            src={cstOrderData.rofile_url}
                            aria-label="RO PDF Document"
                          ></embed>
                          {cstOrderData.rofile_url ? (
                            <div className="d-flex gap-1 items-center mb-3">
                              <p className="text-xs text-blue-400 m-0">
                                {cstOrderData.rofile_url}
                              </p>
                              <sl-icon-button
                                title="View campaign certificate Document"
                                library="lucide"
                                name="view"
                                onClick={() => {
                                  setPdfUrl(cstOrderData.rofile_url);
                                }}
                              ></sl-icon-button>
                            </div>
                          ) : null}
                        </div>
                      </section>
                    ) : null}

                    {cstOrderData.sdcfile_url ? (
                      <section className="bg-slate-50 py-4 px-6 rounded-lg">
                        <div className="flex justify-between mb-2 flex-col  h-[350px]">
                          <label className="text-slate-500">SDC File :</label>{" "}
                          <embed
                            className="w-full h-full"
                            type="application/pdf"
                            src={cstOrderData.sdcfile_url}
                            aria-label="RO PDF Document"
                          ></embed>
                          {cstOrderData.sdcfile_url ? (
                            <div className="d-flex gap-1 items-center mb-3">
                              <p className="text-xs text-blue-400 m-0">
                                {cstOrderData.sdcfile_url}
                              </p>
                              <sl-icon-button
                                title="View campaign certificate Document"
                                library="lucide"
                                name="view"
                                onClick={() => {
                                  setPdfUrl(cstOrderData.sdcfile_url);
                                }}
                              ></sl-icon-button>
                            </div>
                          ) : null}
                        </div>
                      </section>
                    ) : null}
                  </>
                ) : null}
              </div>
            </section>
          </div>
        </>
      ) : null}

      {/* <div className={styles["actionBtns"]}> */}
      <div slot="footer" className="flex gap-2 justify-end flex-wrap">

      {viewData?.rofile_url ? (
        <SlButton
          variant="neutral"
          // slot="footer"
          onClick={() => {
            handleDownload(viewData?.rofile_url, `${viewData?.brand_name}_RO`);
          }}
          size="small"
        >
          <SlIcon slot="prefix" name="arrow-down-short"></SlIcon>
          <span>Download RO</span>
        </SlButton>
      ) : null}
      {viewData?.nonbillfile_url ? (
        <SlButton
          // slot="footer"
          variant="neutral"
          onClick={() => {
            handleDownload(
              viewData?.nonbillfile_url,
              `${viewData?.brand_name}_Reason`
            );
          }}
          size="small"
        >
          <SlIcon slot="prefix" name="arrow-down-short"></SlIcon>{" "}
          <span>Non Billing Reason</span>
        </SlButton>
      ) : null}
      {viewData?.pdcfile_url ? (
        <SlButton
          // slot="footer"
          variant="neutral"
          onClick={() => {
            handleDownload(
              viewData?.pdcfile_url,
              `${viewData?.brand_name}_PDC_file`
            );
          }}
          size="small"
        >
          <SlIcon slot="prefix" name="arrow-down-short"></SlIcon>{" "}
          <span>PDC File</span>
        </SlButton>
      ) : null}
      {(viewData?.status === 2 &&
        localStorage.getItem("role") === roles.financer &&
        viewData.finApprove) ||
      (viewData?.status === 1 &&
        localStorage.getItem("role") === roles.salesperson &&
        viewData.headApprove) ? (
        <>
          <SlButton
            // slot="footer"
            variant="danger"
            onClick={() => {
              setShowRejectModal(true);
            }}
            size="small"
          >
            <SlIcon slot="prefix" name="x-lg"></SlIcon> <span>Reject</span>
          </SlButton>

          <SlButton
            // slot="footer"
            variant="success"
            onClick={() => {
              if (localStorage.getItem("role") === roles.salesperson)
                setShowApproveModal(true);
              else handleApprove();
            }}
            size="small"
          >
            <SlIcon slot="prefix" name="check2"></SlIcon> <span>Approve</span>
          </SlButton>
        </>
      ) : null}
      {viewData &&
      !viewData?.order_id &&
      localStorage.getItem("role") === roles.ops ? (
        <SlButton
          // slot="footer"
          variant="primary"
          onClick={() => handleCreateSlotOrder(viewData?.slot_id)}
          size="small"
        >
          <SlIcon slot="prefix" name="check2"></SlIcon> <span>Pick Order</span>
        </SlButton>
      ) : null}
      {localStorage.getItem("role") === roles.ops &&
      cstOrderData?.cstApprove ? (
        <>
          <SlButton
            // slot="footer"
            variant="success"
            onClick={() =>
              handleCSTHeadApprove({
                order_id: cstOrderData?.order_id,
                action: true,
              })
            }
            size="small"
          >
            <SlIcon slot="prefix" name="check2"></SlIcon>{" "}
            <span>Approve Edits</span>
          </SlButton>
          <SlButton
            // slot="footer"
            variant="danger"
            onClick={() =>
              setCstHeadAppRejObj({
                order_id: cstOrderData?.order_id,
                action: false,
              })
            }
            size="small"
          >
            <SlIcon slot="prefix" name="x-lg"></SlIcon> <span>Reject</span>
          </SlButton>
        </>
      ) : null}
      {localStorage.getItem("role") === roles.ops ? (
        <>
          <SlButton
            // slot="footer"
            variant="neutral"
            onClick={() => handleViewEditHistory(true)}
            size="small"
          >
            <SlIcon slot="prefix" name="pencil"></SlIcon>{" "}
            <span>Sales Order Edits</span>
          </SlButton>
          <SlButton
            // slot="footer"
            variant="neutral"
            onClick={() => setOrderEditLogsId(cstOrderData.order_id)}
            size="small"
          >
            <SlIcon slot="prefix" name="pencil"></SlIcon>{" "}
            <span>CST Order Edits</span>
          </SlButton>
        </>
      ) : null}
      {viewData &&
      ((localStorage.getItem("role") === roles.financer &&
        viewData?.finApprove &&
        viewData?.status === 3) ||
        (localStorage.getItem("role") === roles.salesperson &&
          viewData.headApprove &&
          (viewData?.status === 3 || viewData?.status === 2))) ? (
        <SlButton
          // slot="footer"
          variant="danger"
          onClick={() => {
            setShowRejectModal(true);
          }}
          size="small"
        >
          <SlIcon slot="prefix" name="x-lg"></SlIcon> <span>Reject</span>
        </SlButton>
      ) : null}
      </div>
      {showRejectModal && (
        <div>
          <div className={styles["pos-popup-container"]} style={{ zIndex: 10 }}>
            <form onSubmit={rejectForm.handleSubmit(handleReject)}>
              <div className={styles["pos-popup-header"]}>
                <h3>Reject Order</h3>
                <span
                  className={styles["close"]}
                  onClick={() => {
                    setShowRejectModal(false);
                    rejectForm.reset();
                  }}
                >
                  <img src={closeCrossIconSvg} alt="Close" />
                </span>
              </div>
              <div className={styles["pos-popup-body"]}>
                <div className={styles["form-container"]}>
                  <div className={styles["field-set-tree"]}>
                    <h6>Quick Reasons to Rejection</h6>
                    <div className={styles["field-row"]}>
                      <div className={styles["r-contain"]}>
                        <input
                          type="checkbox"
                          id="reason-1"
                          value={1}
                          {...rejectForm.register("reason", {
                            validate: validateReasons,
                          })}
                        />
                        <label htmlFor="reason-1">RO is not clear</label>
                      </div>
                      <div className={styles["r-contain"]}>
                        <input
                          type="checkbox"
                          id="reason-2"
                          value={2}
                          {...rejectForm.register("reason", {
                            validate: validateReasons,
                          })}
                        />
                        <label htmlFor="reason-2">
                          RO &amp; Value Mis-matched
                        </label>
                      </div>
                      <div className={styles["r-contain"]}>
                        <input
                          type="checkbox"
                          id="reason-3"
                          value={3}
                          {...rejectForm.register("reason", {
                            validate: validateReasons,
                          })}
                        />
                        <label htmlFor="reason-3">Transaction Not Found</label>
                      </div>
                      <div className={styles["r-contain"]}>
                        <input
                          type="checkbox"
                          id="reason-4"
                          value={4}
                          {...rejectForm.register("reason", {
                            validate: validateReasons,
                          })}
                        />
                        <label htmlFor="reason-4">Date Mis-matched</label>
                      </div>
                      <div className={styles["r-contain"]}>
                        <input
                          type="checkbox"
                          id="reason-5"
                          value={5}
                          {...rejectForm.register("reason", {
                            validate: validateReasons,
                          })}
                        />
                        <label htmlFor="reason-5">Position Not Matched</label>
                      </div>
                    </div>
                    {rejectForm.formState.errors?.reason && (
                      <p className="text-red-500 text-xs">
                        Please select at least one reason.
                      </p>
                    )}
                    <h6>Describe A Brief Reason</h6>
                    <div
                      className={`${styles["field-row"]} flex-col items-start`}
                    >
                      <textarea
                        className={styles["description"]}
                        placeholder="Write your reason here..."
                        {...rejectForm.register("description", {
                          required: true,
                        })}
                      />
                      {rejectForm.formState.errors?.description && (
                        <p className="text-red-500 text-xs">
                          This is a required Field
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles["pos-popup-footer"]}>
                <button
                  className={styles["btn-cancel"]}
                  onClick={() => {
                    rejectForm.reset();
                    setShowRejectModal(false);
                  }}
                >
                  <span>Cancel</span>
                </button>
                <button className={styles["btn-submit-reject"]} type="submit">
                  <img src={rejectSvg} alt="submit" />
                  <span>Submit &amp; Reject Order</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      {showApproveModal && (
        <div>
          <div className={styles["pos-popup-container"]} style={{ zIndex: 10 }}>
            <form onSubmit={approveForm.handleSubmit(handleApprove)}>
              <div className={styles["pos-popup-header"]}>
                <h3>Approve Order</h3>
                <span
                  className={styles["close"]}
                  onClick={() => {
                    setShowApproveModal(false);
                    approveForm.reset();
                    setApproveReasonUrl("");
                  }}
                >
                  <img src={closeCrossIconSvg} alt="Close" />
                </span>
              </div>
              <div className={styles["pos-popup-body"]}>
                <div className={styles["form-container"]}>
                  <div className={styles["field-set-tree"]}>
                    <h6>Reason File</h6>
                    <div className={styles["field-row"]}>
                      <div className="d-flex flex-col">
                        <input
                          type="file"
                          className="form-control"
                          aria-label=""
                          name="approvereason_url"
                          id="approvereason_url"
                          accept="application/pdf"
                          {...approveForm.register("approvereason_url", {
                            required: true,
                            onChange: (e) =>
                              handleFileChange(e, "approvereason_url"),
                          })}
                        />
                        {approveReasonprogress > 0 &&
                        approveReasonprogress < 100 ? (
                          <SlProgressBar
                            className="w-full"
                            value={approveReasonprogress}
                          >
                            {approveReasonprogress}%
                          </SlProgressBar>
                        ) : approveReasonUrl ? (
                          <div className="d-flex gap-1 items-center mb-3">
                            <p className="text-xs text-blue-400 m-0">
                              {approveReasonUrl || "-"}
                            </p>
                            <sl-icon-button
                              title="View RO"
                              library="lucide"
                              name="view"
                              onClick={() => {
                                setPdfUrl(approveReasonUrl);
                              }}
                            ></sl-icon-button>
                          </div>
                        ) : null}
                        {approveForm.formState.errors?.approvereason_url && (
                          <span
                            id="formikError"
                            className="text-red-500 text-xs"
                          >
                            {"Reason Required"}
                          </span>
                        )}
                      </div>
                    </div>

                    <h6>Describe A Brief Reason</h6>
                    <div
                      className={`${styles["field-row"]} flex-col items-start`}
                    >
                      <textarea
                        className={styles["description"]}
                        placeholder="Write your reason here..."
                        {...approveForm.register("description", {
                          required: true,
                        })}
                      />
                      {approveForm.formState.errors?.description && (
                        <p className="text-red-500 text-xs">
                          This is a required Field
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles["pos-popup-footer"]}>
                <button
                  className={styles["btn-cancel"]}
                  onClick={() => {
                    approveForm.reset();
                    setShowApproveModal(false);
                  }}
                >
                  <span>Cancel</span>
                </button>
                <SlButton
                  slot="footer"
                  variant="success"
                  type="submit"
                  size="small"
                >
                  <SlIcon slot="prefix" name="check2"></SlIcon>{" "}
                  <span>Approve</span>
                </SlButton>
              </div>
            </form>
          </div>
        </div>
      )}
      {cstHeadAppRejObj?.action === false && (
        <div className={styles["cstreject"]}>
          <div className={styles["pos-popup-container"]} style={{ zIndex: 10 }}>
            <form onSubmit={rejectForm.handleSubmit(handleCSTHeadApprove)}>
              <div className={styles["pos-popup-header"]}>
                <h3>Reject Order</h3>
                <span
                  className={styles["close"]}
                  onClick={() => {
                    setCstHeadAppRejObj(null);
                    rejectForm.reset();
                  }}
                >
                  <img src={closeCrossIconSvg} alt="Close" />
                </span>
              </div>
              <div className={styles["pos-popup-body"]}>
                <div className={styles["form-container"]}>
                  <div className={styles["field-set-tree"]}>
                    <h6>Describe A Brief Reason</h6>
                    <div
                      className={`${styles["field-row"]} flex-col items-start`}
                    >
                      <textarea
                        className={styles["description"]}
                        placeholder="Write your reason here..."
                        {...rejectForm.register("reason", {
                          required: true,
                        })}
                      />
                      {rejectForm.formState.errors?.description && (
                        <p className="text-red-500 text-xs">
                          This is a required Field
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles["pos-popup-footer"]}>
                <button
                  className={styles["btn-cancel"]}
                  onClick={() => {
                    rejectForm.reset();
                    setCstHeadAppRejObj(null);
                  }}
                >
                  <span>Cancel</span>
                </button>
                <button className={styles["btn-submit-reject"]} type="submit">
                  <img src={rejectSvg} alt="submit" />
                  <span>Submit &amp; Reject CST Order</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      {pdfUrl ? (
        <PdfViewer
          url={pdfUrl}
          show={pdfUrl}
          setShow={setPdfUrl}
          placement={"start"}
        />
      ) : null}
      {viewEditHistoryId ? (
        <SlotHistory
          slotLog_id={viewEditHistoryId}
          setSlotLog_id={setViewEditHistoryId}
        />
      ) : null}
      {orderEditLogsId ? (
        <OrderEditLogs
          order_id={orderEditLogsId}
          setOrder_id={setOrderEditLogsId}
        />
      ) : null}
    </SlDrawer>
  );
}

export default SlotVIew;

// className={` ${
//   viewData.date_ranges[0].start_date < midnight
//     ? styles["disabled"]
//     : ""
// }`}
